import React from 'react'
import SkeletonAlertsButtons from './SkeletonAlertsButtons'

const SkeletonNotificationHeader = () => {
    return (
        <>
            <div className="w-full rounded-[10px] relative min-h-[110px] flex flex-row items-center justify-between px-10 bg-[#7780c4]/50 animate-pulse">
                <div className="flex flex-col justify-center">
                    <div className="h-[31px] w-[150px] bg-lightBG rounded  opacity-50"></div>
                </div>
                <div className="h-[90px] w-[90px] bg-[#7780c4] rounded-full opacity-50 mr-[60px]"></div>
            </div>
            <div className="w-full h-[152px] px-[30px] pt-[26px]">
                <div className="flex flex-row items-center justify-between mt-[15px]">
                    <div className="flex flex-row gap-[15px] animate-pulse">
                        {Array.from({ length: 3 }).map((_, idx) => {
                            let width = 120
                            if (idx === 0) width = 190
                            else if (idx === 1) width = 217
                            else if (idx === 2) width = 190
                            return <div key={idx} className="rounded-[10px] h-[69px] min-w-[137px] max-w-[278px] w-full bg-deepPurple animate-pulse opacity-50" style={{ width }} />
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SkeletonNotificationHeader
